import {
  isResponseOperationalFormCmd,
  toMergeableCmdData,
} from "./assignOperationalFormTask";

export function payloadContainsResponseOperationalForm(cmdPayload) {
  if (!cmdPayload || typeof cmdPayload !== "object") {
    return false;
  }
  if (isResponseOperationalFormCmd(cmdPayload)) {
    return true;
  }
  const stack = cmdPayload.filled_stack;
  if (!Array.isArray(stack)) {
    return false;
  }
  return stack.some(
    (entry) => entry && entry.type === "cmd" && isResponseOperationalFormCmd(entry)
  );
}

export function isAlarmBindingEmpty(alarm) {
  if (alarm == null) {
    return true;
  }
  if (typeof alarm === "number") {
    return false;
  }
  if (typeof alarm === "string") {
    return alarm.trim() === "";
  }
  if (Array.isArray(alarm)) {
    return alarm.length === 0;
  }
  if (typeof alarm === "object") {
    const raw = alarm.value ?? alarm.id;
    return raw == null || raw === "";
  }
  return false;
}

function applyAlarmWhenEmpty(value, alarmId) {
  const target = toMergeableCmdData(value);
  if (isAlarmBindingEmpty(target.alarm)) {
    target.alarm = { value: alarmId };
  }
  return target;
}

export function mergeResponseOperationalFormAlarmFromContext(payload, alarmId) {
  if (alarmId == null || alarmId === "") {
    return;
  }
  if (isResponseOperationalFormCmd(payload)) {
    if (payload.storage) {
      payload.storage = applyAlarmWhenEmpty(payload.storage, alarmId);
    }
    payload.data = applyAlarmWhenEmpty(payload.data, alarmId);
  }
  const stack = payload.filled_stack;
  if (!Array.isArray(stack)) {
    return;
  }
  stack.forEach((entry) => {
    if (!entry || entry.type !== "cmd" || !isResponseOperationalFormCmd(entry)) {
      return;
    }
    entry.data = applyAlarmWhenEmpty(entry.data, alarmId);
  });
}
